import { DropdownPropType } from 'components/Dropdown';
import { Dispatch, ReactNode, SetStateAction } from 'react';
import { TFunction } from 'react-i18next';

export const enum AccountViewType {
  OVERVIEW = 'overview',
  PROFILE = 'profile',
  PAYMENTS = 'payments',
  SETTINGS = 'settings',
  CONTACT_US = 'contactUs',
  HELP_CENTER = 'help-center',
  IMPERSONATION = 'impersonation',
  NONE = 'NONE',
}

export enum PaymentType {
  CREDIT_CARD = 'credit card',
  BANK_TRANSFER = 'bank transfer',
}

export enum SlideOutPanelViews {
  TOP_UP = 'top-up',
  CUSTOM = 'custom',
}

export enum ModelKeys {
  AMOUNT = 'amount',
  PORTFOLIO_ID = 'portfolioId',
  PAYMENT_TYPE = 'paymentType',
  IS_RECURRING = 'isRecurring',
  START_DATE = 'startDate',
  FREQUENCY_TYPE = 'paymentFrequency',
}

export interface ModelType {
  [ModelKeys.AMOUNT]: number | string;
  [ModelKeys.PORTFOLIO_ID]: string;
  [ModelKeys.PAYMENT_TYPE]: string;
  [ModelKeys.IS_RECURRING]: boolean;
  [ModelKeys.START_DATE]: string;
  [ModelKeys.FREQUENCY_TYPE]: string;
}

export enum TopupSlideoutViewType {
  RECURRING_PAYMENTS = 'recurring-payments',
  OTP_CREDIT_CARD = 'credit-card',
  BANK_TRANSFER = 'bank-transfer',
  STRIPE_OTP_PAYMENT = 'stripe payment form',
  CHECKOUT_OTP_PAYMENT = 'checkout payment form',
  STRIPE_RECURRING_PAYMENT = 'stripe payment recurring form',
  NONE = 'none',
  ERROR = 'error',
  CHECKOUT_COM_ADD_CARD = 'checkout-dot-com-add-card',
}

export interface TopupSlideoutViewState {
  showBackButton: boolean;
  view: TopupSlideoutViewType;
  model?: unknown;
}

export interface RecurringPaymentPrices {
  id: string;
  nickName: string;
  product: string;
  currency: string;
  unitAmount: string;
  recurringInterval: string;
  recurringIntervalCount: number;
}

export type OpenSlideoutFnType = (view: SlideOutPanelViews, config?: Record<string, unknown>) => void;

export enum PasswordChangeValidationKeys {
  MIN_LENGTH_TEST = 'minLengthTest',
  CHAR_CASE_TEST = 'caseTest',
  DIGIT_TEST = 'digitTest',
  SPECIAL_CHAR_TEST = 'specialCharTest',
  SAME_TEST = 'sameTest',
}

export enum SubjectOptionKeys {
  FINANCIAL = 'financial',
  GENERAL = 'general',
  RELATION_MGR = 'relationMgr',
  SUPPORT = 'support',
  UPDATE_DETAILS = 'updateDetails',
  WITHDRAWAL_REQUEST = 'withdrawalRequest',
}

export enum CardSchemeEnum {
  AMEX = 'AMEX',
}

export interface ExtendedDropDownType extends DropdownPropType {
  isSearchable?: boolean;
  name?: string;
  searchText?: string;
  setSearchText?: Dispatch<SetStateAction<string>>;
}

export enum NOTIFICATION_TABLE_REFS {
  ID = 'categoryId',
  NOTIFICATION_TYPE = 'categoryTypeName',
  EMAIL = 'email',
}

export interface IAutoTradeModelProps {
  isOpen: boolean;
  isLoading?: boolean;
  autoTradeEnabled: boolean;
  selectedId: AutoTradeModelEnum;
  modelConfig?: {
    id: AutoTradeModelEnum;
    buttonSection: ReactNode;
    titleSection: ReactNode;
    textSection: ReactNode;
    onClose?: () => void;
  }[];
}

export interface IAutoTradeModelConfigParams {
  t: TFunction;
  isLoading?: boolean;
  toggleAutoTrade: (bool: boolean, selectedId: AutoTradeModelEnum) => void;
  onClose?: () => void;
}

export enum AutoTradeModelEnum {
  NONE = 'none',
  ENABLED = 'enabled',
  DISABLED = 'disabled',
  CONFIRM_ENABLE = 'confirm_enable',
  CONFIRM_DISABLE = 'confirm_disable',
  ERROR = 'error',
}
